'use strict'
module.exports = function infinite (generate) {
  generate = generate || Math.random
  return function (end, cb) {
    if(end) return cb && cb(end)
    return cb(null, generate())
  }
}





//////////////////
// WEBPACK FOOTER
// ./~/pull-stream/sources/infinite.js
// module id = 392
// module chunks = 0